import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AccountCompanyService } from '../services/account-company.service';
import { ACCOUNTING_COMPANY_HTTP_HEADER } from '../constants/accounting-company.constants';

/**
 * Sends X-Accounting-Company-Id only for company-owned APIs (Accounts masters/vouchers/reports,
 * AccountCompanyWiseConfig, LabelGeneration, Dashboard stats for items/stock groups,
 * AccountItemDesign, AccountEstimate).
 *
 * Intentionally GLOBAL (no company header): DailyMetalRate, Users, AccessRights, AppModules,
 * CompanyDetails (legacy), AuditLogs.
 */
const ACCOUNTING_API_PATTERN =
  /\/Account(?:Ledger|Group|Voucher|Stock|Unit|Godown|Report|GstReport|Bill|ItemDesign|Estimate|ingImport)/i;

const COMPANY_SCOPED_API_PATTERN =
  /\/(?:LabelGeneration|Dashboard|ItemWiseProfitLoss|StockReport)(?:\/|$)/i;

function isAccountingScopedRequest(url: string): boolean {
  if (COMPANY_SCOPED_API_PATTERN.test(url)) return true;
  if (!/\/Account/i.test(url)) return false;
  if (/\/AccountCompany(?:\/|$)/i.test(url) && !/\/AccountCompanyWiseConfig/i.test(url)) {
    return false;
  }
  return ACCOUNTING_API_PATTERN.test(url) || /\/AccountCompanyWiseConfig/i.test(url);
}

export const accountingCompanyInterceptor: HttpInterceptorFn = (req, next) => {
  if (!isAccountingScopedRequest(req.url)) {
    return next(req);
  }

  const companyService = inject(AccountCompanyService);
  const companyId = companyService.getActiveCompanyId().trim();
  if (!companyId) {
    return next(req);
  }

  return next(
    req.clone({
      setHeaders: { [ACCOUNTING_COMPANY_HTTP_HEADER]: companyId },
    }),
  );
};
